import { Grid } from '@mui/material';
import { validateEmail } from '@nx-smartmonkey/shared/helpers';
import { HSpacer, RoutalDialog } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import { User } from '../../../../../domain/backoffice/user/User';
import { useUpdateUser } from '../../../../../hooks/backoffice/users/useUpdateUser';
import Button from '../../../../../react-components/Button';
import InputText from '../../../../../react-components/InputText';
import Text from '../../../../../react-components/Text';

type BackofficeClientsUsersEditEmailDialogProps = {
  openDialog: boolean;
  user: User;
  onClose: (hasBeenUpdated: boolean) => void;
};

export const BackofficeClientsUsersEditEmailDialog = ({
  openDialog,
  user,
  onClose,
}: BackofficeClientsUsersEditEmailDialogProps) => {
  const { run: updateUserEmail, success } = useUpdateUser({
    successMessageIntlId: `administration.users.manage_sms.updated_successfully`,
  });
  const [newEmail, setNewEmail] = useState<string | undefined>();

  useEffect(() => {
    setNewEmail(user.email);
  }, [user]);

  useEffect(() => {
    if (success) {
      onClose(true);
    }
  }, [onClose, success]);

  if (!openDialog) return null;

  return (
    <RoutalDialog
      open={openDialog}
      onCloseDialog={() => onClose(false)}
      dialogProps={{
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
      }}
      titleContent={<Text variant="h6" intlId="administration.users.edit.email.title" />}
      footerContent={
        <Grid container justifyContent="flex-end">
          <Button intlId="cancel" variant="flat" onClick={() => onClose(false)} />
          <HSpacer small />
          <Button
            intlId="send"
            disabled={!newEmail || newEmail === `` || !validateEmail(newEmail)}
            onClick={() => updateUserEmail({ userId: user.id, newEmail })}
          />
        </Grid>
      }
    >
      <InputText
        label={<Text tagName="span" variant="label" intlId="administration.users.edit.email" />}
        id="email"
        type="email"
        placeholderIntlId="login.email"
        fieldValue={newEmail}
        required
        onChange={setNewEmail}
        validators={[
          {
            errorMessage: <Text tagName="span" style={{ color: `#E03030` }} intlId="settings.error.invalid_email" />,
            isInvalid: (text?: string) => !text || !validateEmail(text),
          },
        ]}
      />
    </RoutalDialog>
  );
};
